import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/context/LanguageContext";
import { AuthProvider } from "@/context/AuthContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import AIAssistant from "@/components/AIAssistant";
import VisitorTracker from "@/components/VisitorTracker";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Registration from "@/pages/Registration";
import PaymentPending from "@/pages/PaymentPending";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ChangePassword from "@/pages/ChangePassword";
import Dashboard from "@/pages/Dashboard";
import Slots from "@/pages/Zoom";
import Materials from "@/pages/Materials";
import Exercises from "@/pages/Exercises";
import Translator from "@/pages/Translator";
import Admin from "@/pages/Admin";

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <div className="App min-h-screen page-bg flex flex-col">
          <BrowserRouter>
            <VisitorTracker />
            <Header />
            <main className="flex-1">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/register" element={<Registration />} />
                <Route path="/payment/pending" element={<PaymentPending />} />
                <Route path="/login" element={<Login />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/change-password" element={<ChangePassword />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/slots" element={<Slots />} />
                <Route path="/zoom" element={<Slots />} />
                <Route path="/materials" element={<Materials />} />
                <Route path="/exercises" element={<Exercises />} />
                <Route path="/translator" element={<Translator />} />
                <Route path="/admin" element={<Admin />} />
              </Routes>
            </main>
            <AIAssistant />
            <Footer />
          </BrowserRouter>
          <Toaster position="top-right" richColors />
        </div>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
